import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { MessagingService } from "@otimo/messaging";
import { Observable, throwError } from "rxjs";

import { LoggingService } from "./logging.service";

@Injectable({ providedIn: 'root' })
export abstract class HttpBaseService {

    constructor(
        protected http: HttpClient,
        protected messaging: MessagingService,
        protected logging: LoggingService
    ) { }

    protected getQueryParamsFromObject(searchRequest: Object): HttpParams {
        let params = new HttpParams();
        Object.keys(searchRequest).map((key) => {
            //Använd alla egenskaper på config-objektet i requesten
            if (searchRequest[key]) {
                if (searchRequest[key].constructor === Array) {
                    searchRequest[key].forEach((value, index) => {
                        params.set(key + `[${index}]`, value.toString());
                    });
                } else
                    params.set(key, searchRequest[key].toString());
            }
        });
        return params;
    }


    //Handles default RestResults
    protected parseServerApiResponse(response: RestResult): any {
        if (response.Exception == null && response.Result != null)
            return response.Result;
        else 
            throw response.Exception;
    }

    //Handles non 200-codes
    protected handleServerApiError(error: any): Observable<Object> {
        if (typeof error == 'undefined') 
            error = "Undefined error";

        if (typeof error == 'string') {
            this.messaging.showErrorMsg(error);
            this.logging.logException(error);
        }
        else {
            this.messaging.showErrorMsg(`${error.statusText} [${error.status}]`);
            this.logging.logException(`${error.statusText} [${error.status}]`);
        }
        //Return an observable with an error
        return throwError(() => new Error(error.toString()));
    }

    //Handels unexpected exceptions, parsing errors etc.
    protected handleUnexpectedApiError(error: any): void {
        this.messaging.showErrorMsg(error.toString());
        this.logging.logException(error.toString());
    }
}

/**
 * Standard resultatobjekt från backend.
 */
export class RestResult {
    Result: any;
    Exception: Object;
}
